import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { InputField } from 'shared-components/inputs/input-field';
import { injectIntl, intlShape } from 'react-intl';

class RadioGroup extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      errorText: ''
    };

    this.changeHandler = this.changeHandler.bind(this);
    this.renderAddtlInput = this.renderAddtlInput.bind(this);
    this.returnRadioGroupValue = this.returnRadioGroupValue.bind(this);
    this.returnRadioValueId = this.returnRadioValueId.bind(this);
    this.isValid = this.isValid.bind(this);
  }

  changeHandler () {
    this.setState({
      errorText: ''
    });

    const selectedEle = $(`input[name=${this.props.groupName}]:checked`)[0];

    this.props.inputData.map((input) => {
      if (input.collectUserInput || input.addtlText) {
        const userInputEle = document.getElementById(`input-div-${input.ID}`);

        if (selectedEle.id === input.ID) {
          $(userInputEle).removeClass('hide');
        } else {
          $(userInputEle).addClass('hide');
        }
      }
    });
    if (this.props.changeCB) {
      return this.props.changeCB(selectedEle);
    }
  }

  returnRadioGroupValue () {
    let value;
    const selectedEle = document.querySelectorAll(`input[name=${this.props.groupName}]:checked`)[0];
    const userInput = selectedEle ? document.getElementById(`input-${selectedEle.id}`) : '';

    if (userInput) {
      value = userInput.value;
    } else {
      value = selectedEle ? selectedEle.value : '';
    }
    return _.trim(value);
  }

  returnRadioValueId () {
    const selectedEle = document.querySelectorAll(`input[name=${this.props.groupName}]:checked`)[0];
    return selectedEle.id
  }

  isValid () {
    const { customErrorMessage } = this.props;
    const value = this.returnRadioGroupValue();
    let isValid = true;
    let errorText;

    if (this.props.isRequired) {
      if (!value) {
        errorText = customErrorMessage || this.props.intl.formatMessage({ id: 'boards.radio_group.select_reason', defaultMessage: 'Please select or fill in your reason' });
        isValid = false;
      } else if (5 >= value.length) {
        errorText = this.props.intl.formatMessage({ id: 'boards.radio_group.minimum_characters', defaultMessage: 'Minimum is 5 characters' });
        isValid = false;
      } else if (1000 < value.length) {
        errorText = this.props.intl.formatMessage({ id: 'boards.radio_group.maximum_characters', defaultMessage: 'Maximum is 1,000 characters' });
        isValid = false;
      }
    }

    this.setState({
      errorText
    });

    return isValid;
  }

  renderAddtlInput (input) {
    if (input.collectUserInput) {
      return (
        <div id={`input-div-${input.ID}`} className="hide">
          <InputField
            elementID={`input-${input.ID}`}
            inputFieldName="default_textarea"
            placeholder={input.userEnterPlaceholder}
            colSize=" "
          />
        </div>
      );
    }

    if (input.addtlText) {
      return (
        <div id={`input-div-${input.ID}`} className="hide">
          {input.addtlText}
        </div>
      );
    }
  }

  render () {
    return (
      <div>
        {this.props.inputData.map((input) => {
          const inputProps = {
            id: input.ID || input.id,
            name: this.props.groupName,
            onChange: this.changeHandler,
            value: input.value,
            checked: input.checked
          };
          return (
            <div
              key={inputProps.id}
              className={`${this.props.groupName}-class col-xs-12 RadioField custom-control custom-radio margin-md-bottom`}
            >
              <input
                {...inputProps}
                type="radio"
                className="custom-control-input"
              />
              <label
                className="custom-control-label"
                htmlFor={(inputProps.id || '').replace(/\s/g, '-')}
              >
                {input.displayText}
              </label>
              { this.renderAddtlInput(input) }
            </div>
          );
        })}
        <div className="clearfix input-radio-group">
          <div className="help-block inline-help text-danger text-left col-xs-12">{this.state.errorText}</div>
        </div>
      </div>
    );
  }
}

RadioGroup.propTypes = {
  inputData: PropTypes.array, // id, displayText, checked
  groupName: PropTypes.string,
  isRequired: PropTypes.bool,
  changeCB: PropTypes.func,
  customErrorMessage: PropTypes.string,
  intl: intlShape
};

exports.RadioGroup = injectIntl(RadioGroup, { withRef: true });
